import { render, staticRenderFns } from "./CreateSectionModal.vue?vue&type=template&id=6b305919"
import script from "./CreateSectionModal.vue?vue&type=script&lang=js"
export * from "./CreateSectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports